export type ThemePreference = 'light' | 'dark' | 'system' | 'calm' | 'nature';

export type ResolvedThemeMode = 'light' | 'dark';

export type CustomThemeMode = 'calm' | 'nature';

export const THEME_STORAGE_KEY = 'app-theme';

export const THEME_CHANGE_EVENT = 'app-theme-change';

export const isThemePreference = (value: string | null): value is ThemePreference => {
  return value === 'light' || value === 'dark' || value === 'system' || value === 'calm' || value === 'nature';
};

export const getStoredThemePreference = (): ThemePreference => {
  if (typeof window === 'undefined') {
    return 'light';
  }

  const stored = window.localStorage.getItem(THEME_STORAGE_KEY);
  return isThemePreference(stored) ? stored : 'light';
};

export const hasStoredThemePreference = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.localStorage.getItem(THEME_STORAGE_KEY) !== null;
};

export const setStoredThemePreference = (preference: ThemePreference): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(THEME_STORAGE_KEY, preference);
};

export const getSystemThemeMode = (): ResolvedThemeMode => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'light';
  }

  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

export const resolveThemeMode = (
  preference: ThemePreference,
  systemThemeMode: ResolvedThemeMode = getSystemThemeMode(),
): ResolvedThemeMode => {
  switch (preference) {
    case 'dark':
      return 'dark';
    case 'system':
      return systemThemeMode;
    case 'calm':
    case 'nature':
    case 'light':
    default:
      return 'light';
  }
};
